// ----------------------------------------------------------------------------
// Component: Tooltip
// ----------------------------------------------------------------------------
//
// Some JS to handle touch devices
//
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

module.exports = function() {
    // If you click anywhere outside the tooltip, close the tooltip
    $('body').on('touchstart click', function(event) {
        if (!$(event.target).closest('.tooltip').length) {
            $('.tooltip__content').removeClass('tooltip__content--visible tooltip__content--visible-locked');
        }
    });

    // When you hover the tooltip, add open state; if you hover or click, ensure it stays on screen
    $('.tooltip').on('click mouseenter', function(event) {
        $(this).children('.tooltip__content').addClass('tooltip__content--visible');

        // Ensure the tooltip stays on the screen
        if ($(this).children('.tooltip__content').offset().left < 0) {
            $(this).children('.tooltip__content').offset({left: 15});
        }
    });

    // Once your mouse leaves, remove open for hover
    $('.tooltip').on('mouseleave', function(event) {
        $(this).children('.tooltip__content').removeClass('tooltip__content--visible');
    });

    // When you click the tooltip, toggle the open state
    $('.tooltip').on('click', function(event) {
        $(this).children('.tooltip__content').toggleClass('tooltip__content--visible-locked');
    });
};
